function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 6.787V17.08l5 2.5 7.882-3.941L21 17.341V7.674l-4.094-2.34L9 9.287l-5-2.5zM1.724 2.295L9 5.933l7.76-3.88a.5.5 0 01.472.013l6.516 3.723a.5.5 0 01.252.434V21.08a.5.5 0 01-.691.462L17.21 19.02a.5.5 0 00-.415.015l-7.572 3.786a.5.5 0 01-.448 0l-7.5-3.75A.5.5 0 011 18.624V2.742a.5.5 0 01.724-.447z",
  fill: "#444",
  fillRule: "nonzero"
});

function SvgIcMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25
  }, props), _ref);
}

export default SvgIcMap;